import { createSelector } from '@reduxjs/toolkit';
import { EFacilityType } from '../../../../packages/JsonQuery';
import {
  selectHasConditioner,
  selectHasDishwasher,
  selectHasFridge,
  selectHasFurniture,
  selectHasInternet,
  selectHasKitchenFurniture,
  selectHasPhone,
  selectHasTv,
  selectHasWasher,
  selectParkingTypes,
} from 'shared/selectors/jsonQuery';

export const selectFacilitiesValue = createSelector(
  [
    selectHasConditioner,
    selectHasDishwasher,
    selectHasFridge,
    selectHasFurniture,
    selectHasInternet,
    selectHasKitchenFurniture,
    selectHasPhone,
    selectHasTv,
    selectHasWasher,
    selectParkingTypes,
  ],
  (
    hasConditioner,
    hasDishwasher,
    hasFridge,
    hasFurniture,
    hasInternet,
    hasKitchenFurniture,
    hasPhone,
    hasTv,
    hasWasher,
    parkingTypes,
  ) => {
    const facilityTypes: EFacilityType[] = [];

    if (hasConditioner) {
      facilityTypes.push(EFacilityType.Conditioner);
    }

    if (hasFurniture) {
      facilityTypes.push(EFacilityType.RoomFurniture);
    }

    if (hasKitchenFurniture && hasFurniture !== false) {
      facilityTypes.push(EFacilityType.KitchenFurniture);
    }

    if (hasFurniture === false) {
      facilityTypes.push(EFacilityType.WithoutFurniture);
    }

    if (hasInternet) {
      facilityTypes.push(EFacilityType.Internet);
    }

    if (hasFridge) {
      facilityTypes.push(EFacilityType.Fridge);
    }

    if (hasPhone) {
      facilityTypes.push(EFacilityType.Phone);
    }

    if (hasDishwasher) {
      facilityTypes.push(EFacilityType.Dishwasher);
    }

    if (hasTv) {
      facilityTypes.push(EFacilityType.TV);
    }

    if (hasWasher) {
      facilityTypes.push(EFacilityType.Washer);
    }

    if (parkingTypes && parkingTypes.length > 0) {
      facilityTypes.push(EFacilityType.Parking);
    }

    return facilityTypes.length > 0 ? facilityTypes : null;
  },
);
